//region 2. Project Libraries
import { logger } from '../DataAPI';
//endregion

export default function checkStreamIndex(req, res, next) {
        const log = (lvl, msg) => logger.log(lvl, msg, { tags: 'checkStreamIndex' });
        log('debug', JSON.stringify(req.params, null, 2));
        const index = req.params.index;
        if (!index) {
                const message = 'No Stream Index';
                log('error', message);
                res.status(400).send(message);
                return;
        }
        if (!Number.isInteger(Number(index)) || Number(index) < 0) {
                const message = `Invalid Stream Index ${index}`;
                log('error', message);
                res.status(400).send(message);
                return;
        }
        next();
}
